import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import Money from "@/components/Money.vue";
import { mapGetters } from "vuex";
let PrintTreatmentsModal = class PrintTreatmentsModal extends Vue {
    getMyCompany;
    getTreatmentsStore;
    id;
    get company() {
        return this.getMyCompany('mine');
    }
    get treatments() {
        return this.getTreatmentsStore({}).data;
    }
    get billing() {
        return { ...this.company.billing, contacts: this.company.contacts, avatar: this.company.avatar };
    }
    hidden() {
        var $printSection = document.getElementById("printSection");
        if ($printSection) {
            $printSection.remove();
        }
    }
    print() {
        var printContent = document.getElementById("printContent");
        if (!printContent)
            return;
        var domClone = printContent.cloneNode(true);
        var $printSection = document.getElementById("printSection");
        if (!$printSection) {
            $printSection = document.createElement("div");
            $printSection.id = "printSection";
            document.body.appendChild($printSection);
        }
        $printSection.innerHTML = "";
        $printSection.appendChild(domClone);
        window.onafterprint = () => {
            this.close();
        };
        setTimeout(function () {
            window.print();
        }, 500);
    }
    shown() {
        setTimeout(this.print, 0); // makes sure content is rendered before printing the page
    }
    close() {
        this.$root.$emit("bv::hide::modal", this.id);
    }
};
__decorate([
    Prop({ type: String, required: true })
], PrintTreatmentsModal.prototype, "id", void 0);
PrintTreatmentsModal = __decorate([
    Component({
        components: { Modal, Money },
        computed: {
            ...mapGetters('my-company', { getMyCompany: 'get' }),
            ...mapGetters('treatment', { getTreatmentsStore: 'find' }),
        }
    })
], PrintTreatmentsModal);
export default PrintTreatmentsModal;
